import { FC, SetStateAction } from 'react';
import { ConfirmReasonDialog } from '../../component/ConfirmReasonDialog';
import PageKeThuoc from '../../phan-he-kham-benh/modals/modal-ke-thuoc/PageKeThuoc';
import ModalKeVatTu from '../../phan-he-kham-benh/modals/modal-ke-vat-tu/ModalKeVatTu';
import ModalThuocVatTuTieuHao from '../../phan-he-cdha-va-tdcn/components/modals/ModalThuocVatTuTieuHao';
import PageChiDinhDichVu from '../../phan-he-kham-benh/modals/modal-chi-dinh-dich-vu/PageChiDinhDichVu';
import ChiDinhDichVu from '../../phan-he-noi-tru-dieu-tri/components/chi-dinh-dich-vu';
import { ConfirmDialog } from '../../component/ConfirmDialog';
import ModalDsPhieuThucHien from '../../phan-he-chuyen-khoa/components/modal-thuc-hien/ModalDsPhieuThucHien';

interface DynamicProps {
  data: any,
  setData: SetStateAction<any>,
  handleCancelService?: (value: any) => void,
  generalInfo?: any;
  onConfirm?: () => void;
  onUpdate?: () => void;
  isInpatient?: boolean;
}

const DynamicComponentXN: FC<DynamicProps> = (props) => {
  const { data, setData, handleCancelService, generalInfo, onConfirm, onUpdate, isInpatient } = props;
  
  const Default = () => {
    return <div>Không có nội dung</div>;
  };

  const Confirm = () => {
    const onOK = () => {
	  onConfirm ? onConfirm() : data.submit();
      setData(null);
	  data?.cancel();
    };

    return (
		<ConfirmDialog
			show={data?.componentName === 'Confirm'}
			title='Xác nhận'
			message={`Bạn chắc chắn muốn ${data.nameReq} ?`}
			yes='Có'
			close='Không'
			onYesClick={onOK}
			onCloseClick={() => {
				setData(null);
				data?.cancel();
			}}
		/>
    );
  };

  const ConfirmCancel = () => {

    return (
      <ConfirmReasonDialog
        show={data?.componentName === 'ConfirmCancel'}
        close="Hủy"
        yes="Lưu"
        onYesClick={(values) => {
          handleCancelService?.(values);
          setData(null);
		  data?.cancel();
        }}
        onCloseClick={() => {
			setData(null);
			data?.cancel();
		}}
        title="Không thực hiện dịch vụ"
        name="canceledReason"
        label="Lý do không thực hiện dịch vụ"
      />
    );
  };

  const onClose = () => {
    setData('');
  };

  const components: { [key: string]: any } = {
		Confirm: Confirm,
		ConfirmCancel: ConfirmCancel,
		medicationPrescription: () => (
			<PageKeThuoc
				open
				handleClose={onClose}
				generalInfo={{
					...generalInfo,
					isReturn: false,
				}}
				onSave={onClose}
			/>
		),
		suppliesPrescription: () => (
			<ModalKeVatTu
				open
				handleClose={onClose}
				generalInfo={{
					...generalInfo,
					isReturn: false,
				}}
			/>
		),
		medicationReturn: () => (
			<PageKeThuoc
				open
				handleClose={onClose}
				generalInfo={{
					...generalInfo,
					isReturn: true,
				}}
				onSave={onClose}
			/>
		),
		suppliesReturn: () => (
			<ModalKeVatTu
				open
				handleClose={onClose}
				generalInfo={{
					...generalInfo,
					isReturn: true,
				}}
			/>
		),
		medicationAndSuppliesManagement: () => (
			<ModalThuocVatTuTieuHao handleClose={onClose} generalInfo={generalInfo} />
		),
		executeBatch: () => (
			<ModalDsPhieuThucHien
				open
				handleClose={onClose}
				wfData={data}
				onUpdate={onUpdate}
			/>
		),
		ChiDinhDichVu: () =>
			isInpatient ? (
				<ChiDinhDichVu
					handleClose={() => {
						setData(null);
						data?.cancel();
						data?.callbackFunc();
						data?.updateWorkflow?.();
					}}
					orderGroupId={data?.orderGroupId}
				/>
			) : (
				<PageChiDinhDichVu
					show
					handleClose={() => {
						setData(null);
						data?.cancel();
						data?.callbackFunc();
						data?.updateWorkflow?.();
					}}
					orderGroupId={data?.orderGroupId}
					generalInfo={generalInfo}
					onUpdate={onUpdate}
				/>
			),
  };

  const DynamicContent = components[data?.componentName] || Default;

  return <DynamicContent {...data} />;
};

export default DynamicComponentXN;